export default __webpack_public_path__ + "static/media/logo.108ce744.png";